import React from 'react';
import {
  Route,
  BrowserRouter as Router
} from 'react-router-dom';
import HomePage from './components/Home';
import Navigation from "./components/Navigation";
import { withAuthentication } from "./components/Session";
import {CssBaseline, ThemeProvider, withStyles} from "@material-ui/core";
import {appTheme, appStyles} from "./styles";
import {compose} from "recompose";
import {providesSessionData} from "./components/Session/withSessionData";
import withFlightOptions from "./components/Session/withFlightOptions";
import {ROUTES} from "./constants/routes";

const App = (props) => {
    const {classes} = props;
    return (
        <ThemeProvider theme={appTheme}>
            <CssBaseline />
            <Router>
                <Navigation />
                {Object.values(ROUTES).map((route, index) => {
                    return(
                        <React.Fragment key={index}>
                        {route.noFrame ?
                            <Route path={route.path} component={route.component}/>
                        :
                            <main className={classes.layout}>
                                <Route path={route.path} component={route.component}/>
                            </main>
                        }
                        </React.Fragment>
                    );
                })}
                <main className={classes.layout}>
                    <Route exact path={"/"} component={HomePage}/>
                </main>
            </Router>
            </ThemeProvider>
    );
};

export default compose(
    withAuthentication,
    withFlightOptions,
    withStyles(appStyles),
    providesSessionData,
)(App);
